import React, { useState, useEffect, useRef } from 'react';
import { Table } from 'antd';

import { TableCol } from './getTableCol';

import { courseStruct } from './struct';

export const Supervision = ({ courses }) => {
    const { table } = courseStruct;
    const [_courses, setCourses] = useState(courses && courses.length ? courses : []);

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        setCourses(courses && courses.length ? courses : []);
    }, [courses]);



    const columns = [
        ...TableCol(),
    ];

    return courses ? (
        <>
            <Table {...table} columns={columns} dataSource={_courses} />
        </>
    ) : (
        <></>
    );
};